//Add screenshot limit
export const ADD_SCREENSHOT_LIMIT_REQUEST = "ADD_SCREENSHOT_LIMIT_REQUEST";
export const ADD_SCREENSHOT_LIMIT_SUCCESS = "ADD_SCREENSHOT_LIMIT_SUCCESS";
export const ADD_SCREENSHOT_LIMIT_FAIL = "ADD_SCREENSHOT_LIMIT_FAIL";

//Add Idle Time limit
export const ADD_IDLE_TIME_LIMIT_REQUEST = "ADD_IDLE_TIME_LIMIT_REQUEST";
export const ADD_IDLE_TIME_LIMIT_SUCCESS = "ADD_IDLE_TIME_LIMIT_SUCCESS";
export const ADD_IDLE_TIME_LIMIT_FAIL = "ADD_IDLE_TIME_LIMIT_FAIL";

//Add Idle On Or Off
export const ADD_IDLE_REQUEST = "ADD_IDLE_REQUEST";
export const ADD_IDLE_SUCCESS = "ADD_IDLE_SUCCESS";
export const ADD_IDLE_FAIL = "ADD_IDLE_FAIL";

//Add Weekly limit
export const ADD_WEEKLY_LIMIT_REQUEST = "ADD_WEEKLY_LIMIT_REQUEST";
export const ADD_WEEKLY_LIMIT_SUCCESS = "ADD_WEEKLY_LIMIT_SUCCESS";
export const ADD_WEEKLY_LIMIT_FAIL = "ADD_WEEKLY_LIMIT_FAIL";

//Add Notification
export const ADD_NOTIFICATION_REQUEST = "ADD_NOTIFICATION_REQUEST";
export const ADD_NOTIFICATION_SUCCESS = "ADD_NOTIFICATION_SUCCESS";
export const ADD_NOTIFICATION_FAIL = "ADD_NOTIFICATION_FAIL";

//Add Comapny Type
export const ADD_COMPANY_TYPE_REQUEST = "ADD_COMPANY_TYPE_REQUEST";
export const ADD_COMPANY_TYPE_SUCCESS = "ADD_COMPANY_TYPE_SUCCESS";
export const ADD_COMPANY_TYPE_FAIL = "ADD_COMPANY_TYPE_FAIL";

//Add Time Hero
export const ADD_TIMEHERO_REQUEST = "ADD_TIMEHERO_REQUEST";
export const ADD_TIMEHERO_SUCCESS = "ADD_TIMEHERO_SUCCESS";
export const ADD_TIMEHERO_FAIL = "ADD_NOTIFICATION_FAIL";

//Get Data of User Setting By Company
export const GET_DATA_Of_USER_SETTING_BY_COMPANY_REQUEST =
  "GET_DATA_Of_USER_SETTING_BY_COMPANY_REQUEST";
export const GET_DATA_Of_USER_SETTING_BY_COMPANY_SUCCESS =
  "GET_DATA_Of_USER_SETTING_BY_COMPANY_SUCCESS";
export const GET_DATA_Of_USER_SETTING_BY_COMPANY_FAIL =
  "GET_DATA_Of_USER_SETTING_BY_COMPANY_FAIL";

//Get Data of User Setting By Department
export const GET_DATA_Of_USER_SETTING_BY_DEPARTMENT_REQUEST =
  "GET_DATA_Of_USER_SETTING_BY_DEPARTMENT_REQUEST";
export const GET_DATA_Of_USER_SETTING_BY_DEPARTMENT_SUCCESS =
  "GET_DATA_Of_USER_SETTING_BY_DEPARTMENT_SUCCESS";
export const GET_DATA_Of_USER_SETTING_BY_DEPARTMENT_FAIL =
  "GET_DATA_Of_USER_SETTING_BY_DEPARTMENT_FAIL";

//Add Company Setting
export const ADD_COMPANY_SETTING_REQUEST = "ADD_COMPANY_SETTING_REQUEST";
export const ADD_COMPANY_SETTING_SUCCESS = "ADD_COMPANY_SETTING_SUCCESS";
export const ADD_COMPANY_SETTING_FAIL = "ADD_COMPANY_SETTING_FAIL";

//ADD_ALL_COMPANY_USERS_IDLE_TIME
export const ADD_ALL_COMPANY_USERS_IDLE_TIME_REQUEST =
  "ADD_ALL_COMPANY_USERS_IDLE_TIME_REQUEST";
export const ADD_ALL_COMPANY_USERS_IDLE_TIME_SUCCESS =
  "ADD_ALL_COMPANY_USERS_IDLE_TIME_SUCCESS";
export const ADD_ALL_COMPANY_USERS_IDLE_TIME_FAIL =
  "ADD_ALL_COMPANY_USERS_IDLE_TIME_FAIL";

//ADD_ALL_COMPANY_USERS_SCREENSHOT
export const ADD_ALL_COMPANY_USERS_SCREENSHOT_REQUEST =
  "ADD_ALL_COMPANY_USERS_SCREENSHOT_REQUEST";
export const ADD_ALL_COMPANY_USERS_SCREENSHOT_SUCCESS =
  "ADD_ALL_COMPANY_USERS_SCREENSHOT_SUCCESS";
export const ADD_ALL_COMPANY_USERS_SCREENSHOT_FAIL =
  "ADD_ALL_COMPANY_USERS_SCREENSHOT_FAIL";

//ADD_ALL_COMPANY_WEEKLY_LIMIT
export const ADD_ALL_COMPANY_USERS_WEEKLY_LIMIT_REQUEST =
  "ADD_ALL_COMPANY_USERS_WEEKLY_LIMIT_REQUEST";
export const ADD_ALL_COMPANY_USERS_WEEKLY_LIMIT_SUCCESS =
  "ADD_ALL_COMPANY_USERS_WEEKLY_LIMIT_SUCCESS";
export const ADD_ALL_COMPANY_USERS_WEEKLY_LIMIT_FAIL =
  "ADD_ALL_COMPANY_USERS_WEEKLY_LIMIT_FAIL";

//ADD_ALL_COMPANY_TIME_HERO
export const ADD_ALL_COMPANY_USERS_TIME_HERO_REQUEST =
  "ADD_ALL_COMPANY_USERS_TIME_HERO_REQUEST";
export const ADD_ALL_COMPANY_USERS_TIME_HERO_SUCCESS =
  "ADD_ALL_COMPANY_USERS_TIME_HERO_SUCCESS";
export const ADD_ALL_COMPANY_USERS_TIME_HERO_FAIL =
  "ADD_ALL_COMPANY_USERS_TIME_HERO_FAIL";

//GET COMPANY SETTINGS
export const GET_COMPANY_SETTING_REQUEST = "GET_COMPANY_SETTING_REQUEST";
export const GET_COMPANY_SETTING_SUCCESS = "GET_COMPANY_SETTING_SUCCESS";
export const GET_COMPANY_SETTING_FAIL = "GET_COMPANY_SETTING_FAIL";

//ADD_ALL_COMPANY_USERS_APP_TRACK
export const ADD_ALL_COMPANY_USERS_APP_TRACK_REQUEST =
  "ADD_ALL_COMPANY_USERS_APP_TRACK_REQUEST";
export const ADD_ALL_COMPANY_USERS_APP_TRACK_SUCCESS =
  "ADD_ALL_COMPANY_USERS_APP_TRACK_SUCCESS";
export const ADD_ALL_COMPANY_USERS_APP_TRACK_FAIL =
  "ADD_ALL_COMPANY_USERS_APP_TRACK_FAIL";

//Add App Track
export const ADD_APP_TRACK_REQUEST = "ADD_APP_TRACK_REQUEST";
export const ADD_APP_TRACK_SUCCESS = "ADD_APP_TRACK_SUCCESS";
export const ADD_APP_TRACK_FAIL = "ADD_APP_TRACK_FAIL";

//Add PAY RATE
export const ADD_PAY_RATE_REQUEST = "ADD_PAY_RATE_REQUEST";
export const ADD_PAY_RATE_SUCCESS = "ADD_PAY_RATE_SUCCESS";
export const ADD_PAY_RATE_FAIL = "ADD_PAY_RATE_FAIL";

//Add Working Company Setting
export const ADD_WORKING_COMPANY_SETTING_REQUEST =
  "ADD_WORKING_COMPANY_SETTING_REQUEST";
export const ADD_WORKING_COMPANY_SETTING_SUCCESS =
  "ADD_WORKING_COMPANY_SETTING_SUCCESS";
export const ADD_WORKING_COMPANY_SETTING_FAIL =
  "ADD_WORKING_COMPANY_SETTING_FAIL";

//Add Company Work Policy Setting
export const ADD_COMPANY_WORKING_POLICY_REQUEST =
  "ADD_COMPANY_WORKING_POLICY_REQUEST";
export const ADD_COMPANY_WORKING_POLICY_SUCCESS =
  "ADD_COMPANY_WORKING_POLICY_SUCCESS";
export const ADD_COMPANY_WORKING_POLICY_FAIL =
  "ADD_COMPANY_WORKING_POLICY_FAIL";

//ADD_APPROVE_LEAVE_SETIING
export const ADD_APPROVE_LEAVE_SETIING_REQUEST =
  "ADD_APPROVE_LEAVE_SETIING_REQUEST";
export const ADD_APPROVE_LEAVE_SETIING_SUCCESS =
  "ADD_APPROVE_LEAVE_SETIING_SUCCESS";
export const ADD_APPROVE_LEAVE_SETIING_FAIL = "ADD_APPROVE_LEAVE_SETIING_FAIL";

//ADD_REASON_LEAVE_SETIING
export const ADD_REASON_LEAVE_SETIING_REQUEST =
  "ADD_REASON_LEAVE_SETIING_REQUEST";
export const ADD_REASON_LEAVE_SETIING_SUCCESS =
  "ADD_REASON_LEAVE_SETIING_SUCCESS";
export const ADD_REASON_LEAVE_SETIING_FAIL = "ADD_REASON_LEAVE_SETIING_FAIL";

//ADD_LEAVE_CALENDER_SETIING
export const ADD_LEAVE_CALENDER_SETIING_REQUEST =
  "ADD_LEAVE_CALENDER_SETIING_REQUEST";
export const ADD_LEAVE_CALENDER_SETIING_SUCCESS =
  "ADD_LEAVE_CALENDER_SETIING_SUCCESS";
export const ADD_LEAVE_CALENDER_SETIING_FAIL =
  "ADD_LEAVE_CALENDER_SETIING_FAIL";

//ADD_LEAVE_APPROVER_SETIING
export const ADD_LEAVE_APPROVER_SETIING_REQUEST =
  "ADD_LEAVE_APPROVER_SETIING_REQUEST";
export const ADD_LEAVE_APPROVER_SETIING_SUCCESS =
  "ADD_LEAVE_APPROVER_SETIING_SUCCESS";
export const ADD_LEAVE_APPROVER_SETIING_FAIL =
  "ADD_LEAVE_APPROVER_SETIING_FAIL";
//ADD_EXPENSE_APPROVER_SETIING
export const ADD_EXPENSE_APPROVER_SETIING_REQUEST =
  "ADD_EXPENSE_APPROVER_SETIING_REQUEST";
export const ADD_EXPENSE_APPROVER_SETIING_SUCCESS =
  "ADD_EXPENSE_APPROVER_SETIING_SUCCESS";
export const ADD_EXPENSE_APPROVER_SETIING_FAIL =
  "ADD_EXPENSE_APPROVER_SETIING_FAIL";

//ADD_EXCLUDE_LEAVE_SETIING
export const ADD_EXCLUDE_LEAVE_SETIING_REQUEST =
  "ADD_EXCLUDE_LEAVE_SETIING_REQUEST";
export const ADD_EXCLUDE_LEAVE_SETIING_SUCCESS =
  "ADD_EXCLUDE_LEAVE_SETIING_SUCCESS";
export const ADD_EXCLUDE_LEAVE_SETIING_FAIL = "ADD_EXCLUDE_LEAVE_SETIING_FAIL";

//ADD_COMPANY_PAYROLL_COMP_SETTING
export const ADD_COMPANY_PAYROLL_COMP_SETTING_REQUEST =
  "ADD_COMPANY_PAYROLL_COMP_SETTING_REQUEST";
export const ADD_COMPANY_PAYROLL_COMP_SETTING_SUCCESS =
  "ADD_COMPANY_PAYROLL_COMP_SETTING_SUCCESS";
export const ADD_COMPANY_PAYROLL_COMP_SETTING_FAIL =
  "ADD_COMPANY_PAYROLL_COMP_SETTING_FAIL";

//GET_COMPANY_PAYROLL_COMP_SETTING
export const GET_COMPANY_PAYROLL_COMP_SETTING_REQUEST =
  "GET_COMPANY_PAYROLL_COMP_SETTING_REQUEST";
export const GET_COMPANY_PAYROLL_COMP_SETTING_SUCCESS =
  "GET_COMPANY_PAYROLL_COMP_SETTING_SUCCESS";
export const GET_COMPANY_PAYROLL_COMP_SETTING_FAIL =
  "GET_COMPANY_PAYROLL_COMP_SETTING_FAIL";

//ARCHIVED_COMPANY_PAYROLL_COMP_SETTING
export const ARCHIVED_COMPANY_PAYROLL_COMP_SETTING_REQUEST =
  "ARCHIVED_COMPANY_PAYROLL_COMP_SETTING_REQUEST";
export const ARCHIVED_COMPANY_PAYROLL_COMP_SETTING_SUCCESS =
  "ARCHIVED_COMPANY_PAYROLL_COMP_SETTING_SUCCESS";
export const ARCHIVED_COMPANY_PAYROLL_COMP_SETTING_FAIL =
  "ARCHIVED_COMPANY_PAYROLL_COMP_SETTING_FAIL";

//ADD_COMPANY_BASIC_PAYROLL_SETTING
export const ADD_COMPANY_BASIC_PAYROLL_SETTING_REQUEST =
  "ADD_COMPANY_BASIC_PAYROLL_SETTING_REQUEST";
export const ADD_COMPANY_BASIC_PAYROLL_SETTING_SUCCESS =
  "ADD_COMPANY_BASIC_PAYROLL_SETTING_SUCCESS";
export const ADD_COMPANY_BASIC_PAYROLL_SETTING_FAIL =
  "ADD_COMPANY_BASIC_PAYROLL_SETTING_FAIL";

//ADD_COMPANY_DOCUMENT_SETTING
export const ADD_COMPANY_DOCUMENT_SETTING_REQUEST =
  "ADD_COMPANY_DOCUMENT_SETTING_REQUEST";
export const ADD_COMPANY_DOCUMENT_SETTING_SUCCESS =
  "ADD_COMPANY_DOCUMENT_SETTING_SUCCESS";
export const ADD_COMPANY_DOCUMENT_SETTING_FAIL =
  "ADD_COMPANY_DOCUMENT_SETTING_FAIL";
//ARCHIVED_COMPANY_SALARY_COMP_SETTING
export const ARCHIVED_COMPANY_SALARY_COMP_SETTING_REQUEST =
  "ARCHIVED_COMPANY_SALARY_COMP_SETTING_REQUEST";
export const ARCHIVED_COMPANY_SALARY_COMP_SETTING_SUCCESS =
  "ARCHIVED_COMPANY_SALARY_COMP_SETTING_SUCCESS";
export const ARCHIVED_COMPANY_SALARY_COMP_SETTING_FAIL =
  "ARCHIVED_COMPANY_SALARY_COMP_SETTING_FAIL";

//ADD_COMPANY_SALARY_SETTING
export const ADD_COMPANY_SALARY_SETTING_REQUEST =
  "ADD_COMPANY_SALARY_SETTING_REQUEST";
export const ADD_COMPANY_SALARY_SETTING_SUCCESS =
  "ADD_COMPANY_SALARY_SETTING_SUCCESS";
export const ADD_COMPANY_SALARY_SETTING_FAIL =
  "ADD_COMPANY_SALARY_SETTING_FAIL";

//ADD_COMP_SALARY_SETTING
export const ADD_COMP_SALARY_SETTING_REQUEST =
  "ADD_COMP_SALARY_SETTING_REQUEST";
export const ADD_COMP_SALARY_SETTING_SUCCESS =
  "ADD_COMP_SALARY_SETTING_SUCCESS";
export const ADD_COMP_SALARY_SETTING_FAIL = "ADD_COMP_SALARY_SETTING_FAIL";

//DELETE_COMP_SALARY_SETTING
export const DELETE_COMP_SALARY_SETTING_REQUEST =
  "DELETE_COMP_SALARY_SETTING_REQUEST";
export const DELETE_COMP_SALARY_SETTING_SUCCESS =
  "DELETE_COMP_SALARY_SETTING_SUCCESS";
export const DELETE_COMP_SALARY_SETTING_FAIL =
  "DELETE_COMP_SALARY_SETTING_FAIL";

//ADD_COMPANY_TAX_SETTING
export const ADD_COMPANY_TAX_SETTING_REQUEST =
  "ADD_COMPANY_TAX_SETTING_REQUEST";
export const ADD_COMPANY_TAX_SETTING_SUCCESS =
  "ADD_COMPANY_TAX_SETTING_SUCCESS";
export const ADD_COMPANY_TAX_SETTING_FAIL = "ADD_COMPANY_TAX_SETTING_FAIL";

//ARCHIVED_COMPANY_TAX_SETTING
export const ARCHIVED_COMPANY_TAX_SETTING_REQUEST =
  "ARCHIVED_COMPANY_TAX_SETTING_REQUEST";
export const ARCHIVED_COMPANY_TAX_SETTING_SUCCESS =
  "ARCHIVED_COMPANY_TAX_SETTING_SUCCESS";
export const ARCHIVED_COMPANY_TAX_SETTING_FAIL =
  "ARCHIVED_COMPANY_TAX_SETTING_FAIL";

//ADD_ACTIVE_COMPANY_TAX_SETTING
export const ADD_ACTIVE_COMPANY_TAX_SETTING_REQUEST =
  "ADD_ACTIVE_COMPANY_TAX_SETTING_REQUEST";
export const ADD_ACTIVE_COMPANY_TAX_SETTING_SUCCESS =
  "ADD_ACTIVE_COMPANY_TAX_SETTING_SUCCESS";
export const ADD_ACTIVE_COMPANY_TAX_SETTING_FAIL =
  "ADD_ACTIVE_COMPANY_TAX_SETTING_FAIL";

//GET_ALL_BULK_IMPORTS
export const GET_ALL_BULK_IMPORTS_REQUEST = "GET_ALL_BULK_IMPORTS_REQUEST";
export const GET_ALL_BULK_IMPORTS_SUCCESS = "GET_ALL_BULK_IMPORTS_SUCCESS";
export const GET_ALL_BULK_IMPORTS_FAIL = "GET_ALL_BULK_IMPORTS_FAIL";

//GET_ALL_CUSTOM_FIELD
export const GET_ALL_CUSTOM_FIELD_TEMPLATE_REQUEST =
  "GET_ALL_CUSTOM_FIELD_TEMPLATE_REQUEST";
export const GET_ALL_CUSTOM_FIELD_TEMPLATE_SUCCESS =
  "GET_ALL_CUSTOM_FIELD_TEMPLATE_SUCCESS";
export const GET_ALL_CUSTOM_FIELD_TEMPLATE_FAIL =
  "GET_ALL_CUSTOM_FIELD_TEMPLATE_FAIL";

//CREATE_CUSTOM_FIELD
export const CREATE_CUSTOM_FIELD_TEMPLATE_REQUEST =
  "CREATE_CUSTOM_FIELD_TEMPLATE_REQUEST";
export const CREATE_CUSTOM_FIELD_TEMPLATE_SUCCESS =
  "CREATE_CUSTOM_FIELD_TEMPLATE_SUCCESS";
export const CREATE_CUSTOM_FIELD_TEMPLATE_FAIL =
  "CREATE_CUSTOM_FIELD_TEMPLATE_FAIL";

//UPDATE_ONE_CUSTOM_FIELD
export const UPDATE_ONE_CUSTOM_FIELD_REQUEST =
  "UPDATE_ONE_CUSTOM_FIELD_REQUEST";
export const UPDATE_ONE_CUSTOM_FIELD_SUCCESS =
  "UPDATE_ONE_CUSTOM_FIELD_SUCCESS";
export const UPDATE_ONE_CUSTOM_FIELD_FAIL = "UPDATE_ONE_CUSTOM_FIELD_FAIL";

//DELETE_CUSTOM_FIELD
export const DELETE_CUSTOM_FIELD_TEMPLATE_REQUEST =
  "DELETE_CUSTOM_FIELD_TEMPLATE_REQUEST";
export const DELETE_CUSTOM_FIELD_TEMPLATE_SUCCESS =
  "DELETE_CUSTOM_FIELD_TEMPLATE_SUCCESS";
export const DELETE_CUSTOM_FIELD_TEMPLATE_FAIL =
  "DELETE_CUSTOM_FIELD_TEMPLATE_FAIL";

//GET_ALL_COMPANY_STATUSES_ATTENDANCE
export const GET_ALL_COMPANY_STATUSES_ATTENDANCE_REQUEST =
  "GET_ALL_COMPANY_STATUSES_ATTENDANCE_REQUEST";
export const GET_ALL_COMPANY_STATUSES_ATTENDANCE_SUCCESS =
  "GET_ALL_COMPANY_STATUSES_ATTENDANCE_SUCCESS";
export const GET_ALL_COMPANY_STATUSES_ATTENDANCE_FAIL =
  "GET_ALL_COMPANY_STATUSES_ATTENDANCE_FAIL";

//GET_ALL_USER_STATUSES_ATTENDANCE
export const GET_ALL_USER_STATUSES_ATTENDANCE_REQUEST =
  "GET_ALL_USER_STATUSES_ATTENDANCE_REQUEST";
export const GET_ALL_USER_STATUSES_ATTENDANCE_SUCCESS =
  "GET_ALL_USER_STATUSES_ATTENDANCE_SUCCESS";
export const GET_ALL_USER_STATUSES_ATTENDANCE_FAIL =
  "GET_ALL_USER_STATUSES_ATTENDANCE_FAIL";

//CREATE_COMPANY_ATTENDANCE_STATUSES
export const CREATE_COMPANY_ATTENDANCE_STATUSES_REQUEST =
  "CREATE_COMPANY_ATTENDANCE_STATUSES_REQUEST";
export const CREATE_COMPANY_ATTENDANCE_STATUSES_SUCCESS =
  "CREATE_COMPANY_ATTENDANCE_STATUSES_SUCCESS";
export const CREATE_COMPANY_ATTENDANCE_STATUSES_FAIL =
  "CREATE_COMPANY_ATTENDANCE_STATUSES_FAIL";

//UPDATE_COMPANY_ATTENDANCE_STATUSES
export const UPDATE_COMPANY_ATTENDANCE_STATUSES_REQUEST =
  "UPDATE_COMPANY_ATTENDANCE_STATUSES_REQUEST";
export const UPDATE_COMPANY_ATTENDANCE_STATUSES_SUCCESS =
  "UPDATE_COMPANY_ATTENDANCE_STATUSES_SUCCESS";
export const UPDATE_COMPANY_ATTENDANCE_STATUSES_FAIL =
  "UPDATE_COMPANY_ATTENDANCE_STATUSES_FAIL";

//ARCHIVE_COMPANY_ATTENDANCE_STATUSES
export const ARCHIVE_COMPANY_ATTENDANCE_STATUSES_REQUEST =
  "ARCHIVE_COMPANY_ATTENDANCE_STATUSES_REQUEST";
export const ARCHIVE_COMPANY_ATTENDANCE_STATUSES_SUCCESS =
  "ARCHIVE_COMPANY_ATTENDANCE_STATUSES_SUCCESS";
export const ARCHIVE_COMPANY_ATTENDANCE_STATUSES_FAIL =
  "ARCHIVE_COMPANY_ATTENDANCE_STATUSES_FAIL";

//ARCHIVE_USER_ATTENDANCE_STATUSES
export const ARCHIVE_USER_ATTENDANCE_STATUSES_REQUEST =
  "ARCHIVE_USER_ATTENDANCE_STATUSES_REQUEST";
export const ARCHIVE_USER_ATTENDANCE_STATUSES_SUCCESS =
  "ARCHIVE_USER_ATTENDANCE_STATUSES_SUCCESS";
export const ARCHIVE_USER_ATTENDANCE_STATUSES_FAIL =
  "ARCHIVE_USER_ATTENDANCE_STATUSES_FAIL";

//GET_ALL_USER_ATTENDANCE_STATUSES
export const GET_ALL_USER_ATTENDANCE_STATUSES_REQUEST =
  "GET_ALL_USER_ATTENDANCE_STATUSES_REQUEST";
export const GET_ALL_USER_ATTENDANCE_STATUSES_SUCCESS =
  "GET_ALL_USER_ATTENDANCE_STATUSES_SUCCESS";
export const GET_ALL_USER_ATTENDANCE_STATUSES_FAIL =
  "GET_ALL_USER_ATTENDANCE_STATUSES_FAIL";

//CONTACT_SUPPORT
export const CONTACT_SUPPORT_REQUEST = "CONTACT_SUPPORT_REQUEST";
export const CONTACT_SUPPORT_SUCCESS = "CONTACT_SUPPORT_SUCCESS";
export const CONTACT_SUPPORT_FAIL = "CONTACT_SUPPORT_FAIL";

//CONTACT_SUPPORT_EMAIL
export const CONTACT_SUPPORT_EMAIL_REQUEST = "CONTACT_SUPPORT_EMAIL_REQUEST";
export const CONTACT_SUPPORT_EMAIL_SUCCESS = "CONTACT_SUPPORT_EMAIL_SUCCESS";
export const CONTACT_SUPPORT_EMAIL_FAIL = "CONTACT_SUPPORT_EMAIL_FAIL";
